import React from 'react';
import { SwimLaneDiagram } from './components/SwimLaneDiagram';
export function App() {
  return <SwimLaneDiagram data-id="element-0" />;
}